import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { ErrorDialogComponent } from './components/error-dialog.component'
import { MessageDialogComponent } from './components/message-dialog.component'
import { PrintDialogComponent } from './components/print.component'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { SaveDialogComponent } from './components/save.component'
import { MatInputModule } from '@angular/material/input'
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule
} from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'

const components = [
  ErrorDialogComponent,
  MessageDialogComponent,
  PrintDialogComponent,
  SaveDialogComponent
]

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,

    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [components],
  exports: [components]
})
export class DialogModule {
  static forRoot(): ModuleWithProviders<DialogModule> {
    return {
      ngModule: DialogModule,
      providers: [
        {
          provide: MAT_DIALOG_DEFAULT_OPTIONS,
          useValue: {
            hasBackdrop: true
          }
        }
      ]
    }
  }
}
